import React, { useState, useEffect } from "react";
import InputField from "../../component/input-field";
import Select from "react-select";
import { Country } from "country-state-city";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";

// Import Redux
import { useSelector, useDispatch } from "react-redux";
import { masterCatergoryData } from "../../redux/actions/onboarding";

function OnboardingSlide3({
  page,
  formik,
  errorForSlide3BusinessType,
  errorForSlide3Country,
  setErrorForSlide3BusinessType,
  setErrorForSlide3Country,
  SeterrorForSlide3Gst_number,
  errorForSlide3Gst_number
}) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const { masterCategory } = useSelector((state) => state.onboarding);

  const [countries, setCountries] = useState();
  const [employeeNumber, setEmployeeNumber] = useState(null);
  const [businessOption, setBusinessOption] = useState([]);

  useEffect(() => {
    const country = Country.getAllCountries();
    const list = [];
    country?.map((item) =>
      list.push({ value: item.isoCode, label: item.name })
    );
    setCountries(list);
  }, []);

  // Calling get "masterCatergoryData" API
  useEffect(() => {
    if (page === 3) {
      const request = {
        onError: () => {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Business type not found. Please try again later."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
      };
      dispatch(masterCatergoryData(request));
    }
  }, []);

  // Creating options for bussiness types
  useEffect(() => {
    if (masterCategory) {
      const arr = [];
      masterCategory.map((item) => {
        const obj = {
          value: item.activity_category_id,
          label: item.activity_category_name,
        };
        arr.push(obj);
      });
      setBusinessOption(arr);
    }
  }, [masterCategory]);

  return (
    <div
      className="p-16 space-y-4 h-full"
      style={{ maxHeight: "calc(100% - 80px)" }}
    >
      <div className="grid grid-cols-2 gap-4 h-[95%] 2xl:h-[90%]">
        <div className="hidden md:block space-y-4 2xl:space-y-8">
          <div className="block w-[60px]">
            <img
              alt="Logo"
              src={require("../../assets/img/ShiproneLogo.png")}
            />
          </div>
          <div>
            <p className="font-bold text-lg lg:text-xl xl:text-2xl leading-9 tracking-tight">
              Please Tell Us a Bit
            </p>
            <p className="font-bold text-lg lg:text-xl xl:text-2xl leading-9 tracking-tight">
              About Your <span className="text-[#2f80ed]">Organization</span>
            </p>
          </div>
          <div>
            <a
              href="https://meetings.hubspot.com/abidwai/shiperone-workflow-demo"
              target="__blank"
              className="text-[#2f80ed] border-b border-[#2f80ed] font-semibold text-sm leading-10 tracking-tight py-2"
            >
              Schedule Personal Onboarding
            </a>
          </div>
          <div className="pr-8 flex justify-end">
            <div className="bg-[#F2F8FE] rounded-[20px] text-center p-3 2xl:p-6 2xl:w-2/3">
              <InputField
                type="text"
                label="Company Name"
                placeholder="Enter Company Name"
                wrapperClass="my-3"
                name="company_name"
                value={user?.company?.name}
                disabled
              />
            </div>
          </div>
        </div>
        <div className="max-h-1/2 overflow-y-auto">
          <div className="lg:w-[85%] xl:w-[75%] bg-[#F2F8FE] rounded-[20px] p-4 xl:p-6 space-y-3 2xl:space-y-8 h-full overflow-y-auto">
            <div>
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="country"
              >
                Country
              </label>
              <Select
                options={countries}
                className="unresetText"
                placeholder="Select Country"
                menuPortalTarget={document.body}
                onChange={(countryData) => {
                  formik.setFieldValue("country_name", countryData);
                  if (errorForSlide3Country) {
                    setErrorForSlide3Country(!errorForSlide3Country);
                  }
                }}
                value={formik.values.country_name}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "#9B9B9B", // Set your desired color here
                  }),
                }}
                classNames={{
                  control: (style) => {
                    return `!border !shadow-sm ${
                      style.isFocused
                        ? "!border-[--bg-color-300]/50"
                        : "!border-slate-200 hover:!border-gray-300"
                    }`;
                  },
                  container: (style) => {
                    return "!h-[37.5px] !font-inter !text-sm";
                  },
                  menuList: (style) => {
                    return `!max-h-[200px]`;
                  },
                }}
              />
              {errorForSlide3Country && (
                <p className="text-xs text-rose-500 text-left">
                  This field is required!
                </p>
              )}
            </div>
            <InputField
              type="text"
              label="GST / VAT / Sales Tax ID"
              placeholder="GST / VAT / Sales Tax ID"
              name="tax_id"
              value={formik.values.tax_id}
              wrapperClass="my-3 text-left"
              onChange={(event) => {
                formik.setFieldValue("tax_id", event.target.value);
                if (errorForSlide3Gst_number) {
                  SeterrorForSlide3Gst_number(false);
                }
              }}
              onBlur={formik.handleBlur}
              error={errorForSlide3Gst_number ? 'This field is required' : null}
            />
            <div>
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="country"
              >
                Business Type
              </label>
              <Select
                options={businessOption}
                className="unresetText"
                placeholder="Select Business Type"
                onChange={(businessData) => {
                  formik.setFieldValue("business_type", businessData);
                  if (errorForSlide3BusinessType) {
                    setErrorForSlide3BusinessType(!errorForSlide3BusinessType);
                  }
                }}
                value={formik.values.business_type}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "#9B9B9B", // Set your desired color here
                  }),
                }}
                classNames={{
                  control: (style) => {
                    return `!border !shadow-sm ${
                      style.isFocused
                        ? "!border-[--bg-color-300]/50"
                        : "!border-slate-200 hover:!border-gray-300"
                    }`;
                  },
                  container: (style) => {
                    return "!h-[37.5px] !font-inter !text-sm";
                  },
                  menuList: (style) => {
                    return `!max-h-[200px]`;
                  },
                }}
              />
              {errorForSlide3BusinessType && (
                <p className="text-xs text-rose-500 text-left">
                  This field is required!
                </p>
              )}
            </div>
            <div>
              <p className="block text-sm font-medium mb-2">
                No. Of Employees (Optional)
              </p>
              <div className="flex space-x-10 px-2">
                <div className="space-y-2">
                  <div className="space-x-3">
                    <input
                      type="radio"
                      id="option1"
                      name="fav_language"
                      value="1-5"
                      checked={formik.values.employee_number === "1-5"}
                      className="h-3 w-3 ring-4 border-gray-300 appearance-none checked:bg-none checked:border-2 checked:border-white checked:outline-none"
                      onChange={(e) =>
                        formik.setFieldValue("employee_number", e.target.value)
                      }
                    />
                    <label
                      htmlFor="option1"
                      className="text-sm font-medium cursor-pointer text-[#9B9B9B]"
                    >
                      1-5
                    </label>
                  </div>
                  <div className="space-x-3">
                    <input
                      type="radio"
                      id="option2"
                      name="fav_language"
                      value="21-50"
                      checked={formik.values.employee_number === "21-50"}
                      className="h-3 w-3 ring-4 border-gray-300 appearance-none checked:bg-none checked:border-2 checked:border-white checked:outline-none"
                      onChange={(e) =>
                        formik.setFieldValue("employee_number", e.target.value)
                      }
                    />
                    <label
                      htmlFor="option2"
                      className="text-sm font-medium cursor-pointer text-[#9B9B9B]"
                    >
                      21-50
                    </label>
                  </div>
                  <div className="space-x-3">
                    <input
                      type="radio"
                      id="option3"
                      name="fav_language"
                      value="101-500"
                      checked={formik.values.employee_number === "101-500"}
                      className="h-3 w-3 ring-4 border-gray-300 appearance-none checked:bg-none checked:border-2 checked:border-white checked:outline-none"
                      onChange={(e) =>
                        formik.setFieldValue("employee_number", e.target.value)
                      }
                    />
                    <label
                      htmlFor="option3"
                      className="text-sm font-medium cursor-pointer text-[#9B9B9B]"
                    >
                      101-500
                    </label>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="space-x-3">
                    <input
                      type="radio"
                      id="option4"
                      name="fav_language"
                      value="6-20"
                      checked={formik.values.employee_number === "6-20"}
                      className="h-3 w-3 ring-4 border-gray-300 appearance-none checked:bg-none checked:border-2 checked:border-white checked:outline-none"
                      onChange={(e) =>
                        formik.setFieldValue("employee_number", e.target.value)
                      }
                    />
                    <label
                      htmlFor="option4"
                      className="text-sm font-medium cursor-pointer text-[#9B9B9B]"
                    >
                      6-20
                    </label>
                  </div>
                  <div className="space-x-3">
                    <input
                      type="radio"
                      id="option5"
                      name="fav_language"
                      value="51-100"
                      checked={formik.values.employee_number === "51-100"}
                      className="h-3 w-3 ring-4 border-gray-300 appearance-none checked:bg-none checked:border-2 checked:border-white checked:outline-none"
                      onChange={(e) =>
                        formik.setFieldValue("employee_number", e.target.value)
                      }
                    />
                    <label
                      htmlFor="option5"
                      className="text-sm font-medium cursor-pointer text-[#9B9B9B]"
                    >
                      51-100
                    </label>
                  </div>
                  <div className="space-x-3">
                    <input
                      type="radio"
                      id="option6"
                      name="fav_language"
                      value="500+"
                      checked={formik.values.employee_number === "500+"}
                      className="h-3 w-3 ring-4 border-gray-300 appearance-none checked:bg-none checked:border-2 checked:border-white checked:outline-none"
                      onChange={(e) =>
                        formik.setFieldValue("employee_number", e.target.value)
                      }
                    />
                    <label
                      htmlFor="option6"
                      className="text-sm font-medium cursor-pointer text-[#9B9B9B]"
                    >
                      500+
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingSlide3;
